import { createTamagui } from '@tamagui/core'
import { config } from '@tamagui/config/v3'

// Mobile-first theme configuration for Flowcus
const tamaguiConfig = createTamagui({
  ...config,
  themes: {
    ...config.themes,
    // Custom ADHD-optimized themes
    light: {
      ...config.themes.light,
      // ADHD-friendly colors
      adhd_focus: '#9C27B0',
      adhd_break: '#4CAF50', 
      adhd_urgent: '#F44336',
      adhd_completed: '#2196F3',
      // Enhanced contrast for ADHD users
      background: '#FFFFFF',
      backgroundHover: '#F5F5F5',
      color: '#000000',
    },
    dark: {
      ...config.themes.dark,
      // ADHD-friendly dark mode colors
      adhd_focus: '#BA68C8',
      adhd_break: '#66BB6A',
      adhd_urgent: '#EF5350', 
      adhd_completed: '#42A5F5',
      // Reduced eye strain for ADHD users
      background: '#121212',
      backgroundHover: '#1E1E1E',
      color: '#FFFFFF',
    },
  },
  tokens: {
    ...config.tokens,
    // Mobile-first spacing system (4px base)
    space: {
      ...config.tokens.space,
      '$0': 0,
      '$1': 4,
      '$2': 8,
      '$3': 12,
      '$4': 16,
      '$5': 20,
      '$6': 24,
      '$8': 32,
      '$10': 40,
      '$12': 48,
      '$16': 64,
      '$20': 80,
    },
    // Touch-optimized sizes (minimum 44px for mobile)
    size: {
      ...config.tokens.size,
      '$touch': 44, // Minimum touch target
      '$touchLarge': 56, // Larger touch target
      '$card': 80, // Minimum card height
    },
    // Mobile-first radius
    radius: {
      ...config.tokens.radius,
      '$card': 12,
      '$button': 8,
      '$input': 6,
    },
  },
  media: {
    // Mobile-first breakpoints
    xs: { maxWidth: 479 },
    sm: { minWidth: 480 },
    md: { minWidth: 768 },
    lg: { minWidth: 1024 },
    xl: { minWidth: 1200 },
    // Touch device detection
    touch: { hover: 'none' },
    mouse: { hover: 'hover' },
    // Reduced motion for ADHD accessibility
    reducedMotion: { prefersReducedMotion: 'reduce' },
  },
})

export default tamaguiConfig

export type Conf = typeof tamaguiConfig
declare module '@tamagui/core' {
  interface TamaguiCustomConfig extends Conf {}
}